import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-search-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class UniversalFieldArea extends GenericListTab {
    UniversalField: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.UniversalField = parent;
    }
    ControllerUrl = "UniversalFieldArea";
    CustomFilter() {
        return null;
    }
    SearchType() {
        return "Area";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default UniversalFieldArea;